<template>
  <v-row class="my-0" :style="[computedColor]">
    <v-col cols="12" class="d-flex align-center py-0">
      <v-icon class="mr-2" :disabled="disabledBtn" v-if="prependIcon" @click="clickIcon($event)">
        {{prependIcon}}
      </v-icon>

      <div
        class="title-text"
        :class="{ 'text-center': !textStart, 'inline': inline, 'required': required }"
        v-html="title"
        :style="{'font-weight': fontWeight, 'font-size': fontSize + 'px' }"
      />

      <v-icon class="ml-2" :disabled="disabledBtn" v-if="appendIcon" @click="clickIcon($event)">
        {{appendIcon}}
      </v-icon>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Title",

  props: {
    required: Boolean,

    fontWeight: {
      type: [String, Number],
      default: '500'
    },

    fontSize: {
      type: [String, Number],
      default: '26'
    },

    title: {
      type: String,
      default: 'Title'
    },

    textStart: Boolean,

    color: {
      type: String,
      default: '#37474f'
    },

    inline: Boolean,

    appendIcon: String,

    prependIcon: String,

    disabledBtn: Boolean

  },

  computed: {
    computedColor() {
      return {
        '--text-color': this.color
      }
    },
  },

  methods: {
    clickIcon(e) {
      this.appendIcon && this.$emit('click:append-outer', e)
      this.prependIcon && this.$emit('click:prepend-outer', e)
    }
  }
}
</script>

<style scoped>
div {
  line-height: 1 !important;
  /*  font-size: 30px !important;*/
  /*  text-align: center;*/
}

.title-text {
  width: 100%;
  color: var(--text-color);
}

.inline {
  width: auto;
}
</style>
